import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class BaseAuthGuard {
  protected router = inject(Router);
  protected authService = inject(AuthService);

  constructor() { }

  login(route: ActivatedRouteSnapshot) {
    if (!this.authService.isSignOutRequested) {
      this.getResolvedUrl(route);
      this.getForceParam(route);
      this.getQueryParams(route);

      this.authService.login();
    }
  }

  private getResolvedUrl(route: ActivatedRouteSnapshot): void {
    const returnUrl = route.url.concat(route.firstChild?.url || []).join('/');
    sessionStorage.setItem('returnUrl', returnUrl);
  }

  private getForceParam(route: ActivatedRouteSnapshot): void {
    const force = route.queryParams?.force;
    sessionStorage.setItem('force', force);
  }

  private getQueryParams(route: ActivatedRouteSnapshot): void {
    const queryParams = new URLSearchParams(route.queryParams);
    sessionStorage.setItem('queryParams', queryParams.toString());
  }
}
